import { create } from "zustand";

// Configuration des moods pour chaque musique
const MOODS = {
  cappuccino: {
    name: "Cappuccino",
    audioFile: "/assets/Cappuccino.mp3",
    textures: {
      big: "/assets/bake_bigA_4096.jpg",
      med: "/assets/bake_medA_4096.jpg",
      sma: "/assets/bake_smaA_2048.jpg",
    },
    tvColor: "#ff9900",
    tvText: "CAPPUCCINO",
  },
  americano: {
    name: "Americano",
    audioFile: "/assets/Americano.mp3",
    textures: {
      big: "/assets/bake_bigA_4096.jpg",
      med: "/assets/bake_medA_4096.jpg",
      sma: "/assets/bake_smaA_2048.jpg",
    },
    tvColor: "#AAAAAA",
    tvText: "AMERICANO",
  },
  latteCoco: {
    name: "Latte Coco",
    audioFile: "/assets/Latte Coco.mp3",
    textures: {
      big: "/assets/bake_bigA_4096.jpg",
      med: "/assets/bake_medA_4096.jpg",
      sma: "/assets/bake_smaA_2048.jpg",
    },
    tvColor: "#d2691e",
    tvText: "LATTE COCO",
  },
  coffeeLiqueur: {
    name: "Coffee Liqueur",
    audioFile: "/assets/Coffee Liqueur.mp3",
    textures: {
      big: "/assets/bake_bigA_4096.jpg",
      med: "/assets/bake_medA_4096.jpg",
      sma: "/assets/bake_smaA_2048.jpg",
    },
    tvColor: "#9ACD32",
    tvText: "COFFEE\nLIQUEUR",
  },
};

const MOODS_ARRAY = [
  MOODS.cappuccino,
  MOODS.americano,
  MOODS.latteCoco,
  MOODS.coffeeLiqueur,
];

export const useAudioStore = create((set, get) => ({
  audio: null,
  currentMoodIndex: 0,
  isPlaying: false,
  moods: MOODS_ARRAY,
  currentMood: MOODS_ARRAY[0],
  isTransitioning: false,

  initAudio: () => {
    const { moods } = get();
    const audio = new Audio(moods[0].audioFile);
    audio.loop = true;
    audio.volume = 0.5;
    set({ audio, currentMoodIndex: 0, currentMood: moods[0] });
  },

  playAudio: () => {
    const { audio } = get();
    if (audio) {
      audio.play().catch((error) => {
        console.error("Error playing audio:", error);
      });
      set({ isPlaying: true });
    }
  },

  pauseAudio: () => {
    const { audio } = get();
    if (audio) {
      audio.pause();
      set({ isPlaying: false });
    }
  },

  toggleAudio: () => {
    const { isPlaying } = get();
    if (isPlaying) {
      get().pauseAudio();
    } else {
      get().playAudio();
    }
  },

  nextMood: () => {
    const { audio, moods, currentMoodIndex, isTransitioning } = get();

    // Ignorer si une transition est déjà en cours
    if (isTransitioning || !audio) return;

    // Démarrer la transition
    set({ isTransitioning: true });

    const nextIndex = (currentMoodIndex + 1) % moods.length;
    const nextMood = moods[nextIndex];

    // Attendre la fin du fondu au noir (300ms) avant de changer le mood
    setTimeout(() => {
      audio.src = nextMood.audioFile;
      audio.currentTime = 0;
      audio.play().catch((error) => {
        console.error("Error playing next mood:", error);
      });

      set({
        currentMoodIndex: nextIndex,
        currentMood: nextMood,
        isPlaying: true,
      });

      console.log(`Now playing: ${nextMood.name}`);
      console.log(`Mood settings:`, nextMood);

      // Attendre le retour du fondu (300ms) avant de terminer la transition
      setTimeout(() => {
        set({ isTransitioning: false });
      }, 300);
    }, 300);
  },

  setVolume: (volume) => {
    const { audio } = get();
    if (audio) {
      audio.volume = Math.max(0, Math.min(1, volume));
    }
  },
}));

export { MOODS };
